.container {
  width: 100%;
  display: flex;
  align-items: center;
}

.bar {
  flex: 1;
  background-color: var(--tuna-palette-action-hover);
  cursor: pointer;
  margin-right: 4px;
  height: 4px;
}

.level {
  background-color: var(--tuna-palette-primary-light);
  height: 4px;
}
